import React from "react";
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../../assets/images/logo-white.svg";

const Page403 = (props) => {
  const navigate = useNavigate();

  return (
    <div className="theme-cyan">
      <div>
        <div className="vertical-align-wrap">
          <div className="vertical-align-middle auth-main">
            <div className="auth-box">
              <div className="top">
                <img src={Logo} alt="Lucid" style={{ height: "40px", margin: "10px" }} />
              </div>
              <div className="card">
                <div className="header">
                  <h3>
                    <span className="clearfix title">
                      <span className="number left">Error403<br /></span>
                      <span className="text">Forbidden Error!</span>
                    </span>
                  </h3>
                </div>
                <div className="body">
                  <p>You don't have permission to access / on this server.</p>
                  <div className="margin-top-30">
                    <Link to="#" className="btn btn-default" onClick={() => navigate("/")}>
                      <i className="fa fa-arrow-left"></i>&nbsp;<span>Go Back</span>
                    </Link>&nbsp;
                    <a className="btn btn-primary" href="/">
                      <i className="fa fa-home"></i>&nbsp;<span>Home</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(Page403);